import { useMemo, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { fixedEncodeURIComponent } from '../utils/index.js';


export const useQuery = location => {
  const { search, pathname } = useLocation();
  const { push } = useHistory();
  const [ query, setUrlQuery ] = useState(queryString.parse(location || search));
  useMemo(() => {
    setUrlQuery(queryString.parse(search));
  }, [ pathname, search ]);
  const addQuery = obj => {
    push(`${pathname}?${queryString.stringify({ ...query, ...obj })}`);
  };
  const setQuery = obj => {
    push(`${pathname}?${queryString.stringify(obj)}`);
  };

  const removeQuery = (key, value) => {
    push(`${pathname}${search.replace(new RegExp(`(&)?${key}=${fixedEncodeURIComponent(value)}`, 'g'), '')}`);
  };

  const clearQuery = path => {
    push(path || pathname);
  };

  return ({ query, addQuery, setQuery, removeQuery, clearQuery });
};


export const useCurrentPortal = () => {

  const location = useLocation();
  const portal = location.pathname.split('/')[1];

  return portal;
};

export const useLoginRoute = () => {

  const path = `/${useCurrentPortal()}/login`;

  return path;
};


export const useDebounce = (value, delay) => {
  const [ debouncedValue, setDebouncedValue ] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [ value ]);

  return debouncedValue;
};

export const generateQuery = values => {
  const query = {};
  Object.keys(values).forEach(item => {
    if (values[item] !== null && values[item] !== undefined && values[item] !== '') {
      typeof(values[item]) === 'string' ? query[item] = values[item].trim() : query[item] = values[item];
    }
  });

  return query;
};
